<div class="page-wrapper" [ngClass]="[theme === 'dark'? 'dark' : '']">
    <div class="content">
        <div class="order-details">
            <div class="content p-0">
                <!-- <div class="page-header">
                    <div class="page-title">
                        <h4>Details</h4>
                    </div>
                    <div class="page-btn d-flex">
                        <div class="col" style="padding-left: 0;">
                        </div>
                    </div>
                </div> -->

                <div class="row mx-0">
                    <div class="col-md-4 px-1">
                        <div class="card">
                            <div class="profile-detail">
                                <!-- <div class="row address-card p-2">
                                    <div class="col profile-info">
                                        <h2>Kate Velasquez</h2>
                                    </div>
                                    <div class="col-md-4 text-end">
                                        <img src="../../../../assets/img/girl.png" alt="not-found"
                                            class="profile-img img-fluid rounded-circle">
                                    </div>
                                </div> -->
                                <div class="row address-card p-2">
                                    <div class="profile-info">
                                        <div class="col profile-info">
                                            <h2>{{customerData?.accountName}}</h2>
                                            <!-- <p>Product Lead</p> -->
                                        </div>
                                        <!-- <div class="col-md-4 text-end">
                                            <img src="../../../../assets/img/girl.png" alt="not-found"
                                                class="profile-img img-fluid rounded-circle">
                                        </div> -->

                                        <!-- <h6>General Information</h6> -->
                                        <div class="row w-100">
                                            <div class="d-flex align-items-center mb-2">
                                                <!-- <i class="bi bi-telephone fs-5 me-3"></i>  -->
                                                <b class="font-info fw-bold me-2">Mobile: </b>{{customerData?.mobile}}
                                            </div>
                                            <div class="d-flex align-items-center mb-2" *ngIf="customerData?.accountPan">
                                                <b class="font-info fw-bold me-2">Pan: </b> {{customerData?.accountPan}}
                                            </div>
                                            <div class="d-flex align-items-center mb-2" *ngIf="customerData?.cin">
                                                <b class="font-info fw-bold me-2">Cin: </b> {{customerData?.cin}}
                                            </div>
                                             <div class="d-flex align-items-center mb-2" *ngIf="customerData?.accountGst">
                                                <b class="font-info fw-bold me-2">Gstin: </b> {{customerData?.accountGst}}
                                            </div>
                                            
                                             <div class="d-flex align-items-center mb-2">
                                                 <b class="font-info fw-bold me-2">Email:</b>
                                                <a href="mailto:{{customerData?.email}}"
                                                    class="text-decoration-none">{{customerData?.email}}</a>
                                            </div>

                                            <div class="d-flex align-items-right mb-2">
                                                <label class="successPill"><i
                                                        class="bi bi-circle-fill  me-2"></i>Active</label>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <ng-container *ngIf="userType === 'customer' || userType === 'vendor' ">
                        <div class="col-md-8 d-flex flex-column cards-container px-1" style="display: none;">
                            <div class="card flex-fill">
                                <div class="card-body bil-shippaddress">
                                    <div class="profile-info">
                                        <label for="billingAddress" class="custom-font mb-2">Billing Address</label>
                                        <div class="row mb-2">
                                            <div class="col-md-4 font-info">Address:</div>
                                            <div class="col-md-8 fw-bold">{{customerData?.billingAddressLine1}}</div>
                                        </div>
                                        <div class="row mb-2" *ngIf="customerData?.billingAddressLine2">
                                            <div class="col-md-4 font-info">Address 2:</div>
                                            <div class="col-md-8 fw-bold">{{customerData?.billingAddressLine2}}</div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4 font-info">City:</div>
                                            <div class="col-md-8 fw-bold">{{customerData?.billingCityName}}</div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4 font-info">State:</div>
                                            <div class="col-md-8 fw-bold">{{customerData?.billingStateName}}</div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4 font-info">Pincode:</div>
                                            <div class="col-md-8 fw-bold">{{customerData?.billingPincode}}</div>
                                        </div>
                                    </div>
                                     <div class="profile-info">
                                        <label for="shippingAddress" class="custom-font mb-2">Shipping Address</label>
                                        <div class="row mb-2">
                                            <div class="col-md-4 font-info">Address:</div>
                                            <div class="col-md-8 fw-bold">{{customerData?.shippingAddressLine1}}</div>
                                        </div>
                                         <div class="row mb-2" *ngIf="customerData?.shippingAddressLine2">
                                            <div class="col-md-4 font-info">Address 2:</div>
                                            <div class="col-md-8 fw-bold">{{customerData?.shippingAddressLine2}}</div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4 font-info">City:</div>
                                            <div class="col-md-8 fw-bold">{{customerData?.shippingCityName}}</div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4 font-info">State:</div>
                                            <div class="col-md-8 fw-bold">{{customerData?.shippingStateName}}</div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-4 font-info">Pincode:</div>
                                            <div class="col-md-8 fw-bold">{{customerData?.shippingPincode}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card flex-fill mt-2 d-none">
                                <div class="card-body">
                                    <div class="profile-info">
                                        <label for="shippingAddress" class="custom-font mb-2">Shipping Address</label>
                                        <div class="row mb-2">
                                            <div class="col-md-3 font-info">Address:</div>
                                            <div class="col-md-9 fw-bold">{{customerData?.shippingAddressLine1}}</div>
                                        </div>
                                         <div class="row mb-2">
                                            <div class="col-md-3 font-info">Address:</div>
                                            <div class="col-md-9 fw-bold">{{customerData?.shippingAddressLine1}}</div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-3 font-info">City:</div>
                                            <div class="col-md-9 fw-bold">{{customerData?.shippingCityName}}</div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-3 font-info">State:</div>
                                            <div class="col-md-9 fw-bold">{{customerData?.shippingStateName}}</div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-3 font-info">Pincode:</div>
                                            <div class="col-md-9 fw-bold">{{customerData?.shippingPincode}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </ng-container>
                    
                   
                </div>
                <ng-container *ngIf="this.tableLists[0]?.accountLocationMappings.length > 0">
                    <h2 class="custom-font mb-2 mt-4">Location Details</h2>
                    <div class="row mt-2 px-2">
                        <div class="col-md-12 px-1" *ngFor="let warehouse of this.tableLists[0]?.accountLocationMappings">
                            <div class="card about-section mt-2">
                                <div class="card-body">
                                    <div class="profile-info wh-details-block">
                                        <div class="wh-details">
                                        <!-- <h6 class="text-muted">Warehouse</h6> -->
                                        <h5 class="custom-font mb-3">{{ warehouse.warehouseCode }}</h5>

                                        <div class="row mb-2" *ngIf="warehouse?.pocAddress">
                                            <div class="col-4 font-info">Address:</div>
                                            <div class="col-8 fw-bold">{{ warehouse.pocAddress }} {{warehouse?.districtName}} {{warehouse?.stateName}} {{warehouse?.pincode}}</div>
                                        </div>

                                        <!-- <div class="row mb-2">
                                            <div class="col-4 font-info">Warehouse Code</div>
                                            <div class="col-8 fw-bold">{{warehouse.warehouseCode}}</div>
                                        </div> -->
                                        <div class="row mb-2">
                                            <div class="col-4 font-info">GSTIN</div>
                                            <div class="col-8 fw-bold">{{warehouse.gstin}}</div>
                                        </div>
                                        <!-- <div class="row mb-2">
                                            <div class="col-4 font-info">Poc Address</div>
                                            <div class="col-8 fw-bold">{{warehouse.pocAddress}}</div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-4 font-info">Poc Address</div>
                                            <div class="col-8 fw-bold">{{warehouse.pocAddress}}</div>
                                        </div> -->
                                        </div>
                                        <div class="poc-details">
                                        <h5 class="custom-font poc-heading mb-3">POC Details</h5>
                                        <div class="row mb-2">
                                            <div class="col-4 font-info">Name</div>
                                            <div class="col-8 fw-bold">{{warehouse.pocName}}</div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-4 font-info">Mobile</div>
                                            <div class="col-8 fw-bold">{{warehouse.pocMobile}}</div>
                                        </div>
                                        <div class="row mb-2" *ngIf="warehouse.pocAddress">
                                            <div class="col-4 font-info">Address</div>
                                            <div class="col-8 fw-bold">{{warehouse.pocAddress}}</div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

</div>
</div>
